import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "actionId"];
import AdsAudienceMembershipActionSummary from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionSummary';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import { jsx as _jsx } from "react/jsx-runtime";
function AdsAudienceMembershipActionCard(_ref) {
  let {
      getHeaderTitle,
      actionMetadata,
      actionId
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, restProps, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(AdsAudienceMembershipActionSummary, {
      actionMetadata: actionMetadata
    })
  }));
}
export default AdsAudienceMembershipActionCard;